import axios from 'axios';
const API_URL = process.env.REACT_APP_API_ENDPOINT;
axios.defaults.withCredentials = true;

export const getGraphicalStatisticsSignIn = async (values) => {
    const res = await axios.post(`${API_URL}signin-account-report/graphical-statistics`, values);
    return res;
};
export const getDataStatisticsSignIn = async (values) => {
    const res = await axios.post(`${API_URL}signin-account-report/data-statistics`, values);
    return res;
};
